import React from 'react'
import CrowdFunding from './CrowdFunding'

function AdditionalContent1() {



  return (
      <div className='space-y-8'>
      <p className='text-xl font-semibold'>Solar Group - Chicago</p>

       <div>
       <p className='text-xl font-semibold'>Planning</p>
       </div>
       
       <div className=''>
       <p className='text-xl font-semibold'>CrowdFunding</p>
       <CrowdFunding />
       </div>
        
       <div>
       <p className='text-xl font-semibold'>Developing</p>
       </div>

       <div>
       <p className='text-xl font-semibold'>Building</p>
       </div>

       <div>
       <p className='text-xl font-semibold'>Completion</p>
       </div>


      </div>
  )
}

export default AdditionalContent1
